module.exports = __webpack_public_path__ + "static/img/r_5.a7328d2e.png";